import React from 'react';
import DateField from '../utils/DateField';
import { useSelector } from 'react-redux';
import Input from '../utils/Input';
import { formValueSelector } from 'redux-form';
import TextArea from '../utils/TextArea';
import { connect } from 'react-redux';
import { changeStepForm, STEPS } from '../../redux/actions/PasosFormulario';
import { checkCobertura } from '../../redux/actions/Coberturas';
import { Field, reduxForm, submit, getFormSyncErrors } from 'redux-form';
import moment from 'moment';
const selector = formValueSelector('FormDataCliente')


const validate = values => {
    const errors = {}

    if (!values.Nombres) {
        errors.Nombres = 'Campo requerido'
    }

    if (!values.Apellidos) {
        errors.Apellidos = 'Campo requerido'
    }

    if (!values.Correo) {
        errors.Correo = 'Campo requerido'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Correo)) {
        errors.Correo = 'Correo invalido'
    }

    if (!values.CodPostal) {
        errors.CodPostal = 'Campo requerido'
    }

    if (!values.Telefono) {
        errors.Telefono = 'Campo requerido'
    }

    if (!values.Edad) {
        errors.Edad = 'Campo requerido'
    } else {
        if (parseFloat(values.Edad) < 21 || parseFloat(values.Edad) > 70) {
            errors.Edad = 'Edad debe estar entre los 21 y 70 años'
        }
    }

    if (values.Aerolinea) {
        if (!values.NoVuelo) {
            errors.NoVuelo = 'Campo requerido'
        }

        if (!values.FechaArrivo) {
            errors.FechaArrivo = 'Campo requerido'
        }
    }

    if (values.NoVuelo) {
        if (!values.Aerolinea) {
            errors.Aerolinea = 'Campo requerido'
        }

        if (!values.FechaArrivo) {
            errors.FechaArrivo = 'Campo requerido'
        }
    }

    return errors
}




let FormDataCliente = ({ stepBackward, stepFoward, handleSubmit, submitting, synchronousError, checkCobertura, datosCliente }) => {

    const {  stepWay } = useSelector(state => state.pasosReservacion);

    const onChangeCoberturas = (event) => {
        let value = event.target.value;
        if (value <= 24) {
            checkCobertura({ id: "MENORES", checked: true })
        } else {
            checkCobertura({ id: "MENORES", checked: false })
        }
    }

    console.log("   tipo de via FORMDATA *********** ", stepWay);

    let nombreBoton = "SIGUIENTE";  

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-12">
                    <h2>INFORMACIÓN DEL CLIENTE</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <small>* Llenar todos los campos obligatorios</small>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>DATOS PERSONALES</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Field label="* NOMBRES" name="Nombres" component={Input} type="text" className="form-control" placeholder="Ingresa nombres" />
                </div>
                <div className="col-md-6">
                    <Field label="* APELLIDOS" name="Apellidos" component={Input} type="text" className="form-control" placeholder="Ingresa apellidos" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Field label="* CORREO ELECTRÓNICO" name="Correo" component={Input} type="email" className="form-control" placeholder="Ingresa correo electrónico" />
                </div>
                <div className="col-md-3">
                    <Field label="* TÉLEFONO" name="CodPostal" component={Input} type="text" className="form-control" placeholder="Cod. Área" />
                </div>
                <div className="col-md-3">
                    <div className="input-group mb-2">
                        <Field name="Telefono" component="input" type="text" className="form-control" placeholder="Ingresa teléfono" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <Field label="* EDAD" name="Edad" component={Input} onChange={onChangeCoberturas} type="number" className="form-control" placeholder="Edad" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Field label="COMENTARIOS" name="Comentarios" component={TextArea} className="form-control text-area" />
                </div>
            </div>
            <div className="row" style={{ height: "40px" }}></div>
            <div className="row">
                <div className="col-md-12">
                    <h3>DATOS DEL VUELO</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-9">
                    <Field label="AEROLÍNEA" name="Aerolinea" component={Input} type="text" className="form-control" placeholder="Ingresa el nombre de Aerolínea" />
                </div>
                <div className="col-md-3">
                    <Field label="No. VUELO" name="NoVuelo" component={Input} type="text" className="form-control" placeholder="No. Vuelo" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-7">
                    <Field label="FECHA Y HORA DE ARRIVO (GUA)" name="FechaArrivo" component={DateField} type="text" className="form-control" placeholder="Fecha y hora de arrivo a Guatemala" />
                </div>
            </div>
            <div className="row" style={{ height: "70px" }}></div>
            <div className="row">
                <div className="col-md-12 box-buttons">
                    <button type="button" onClick={() => stepBackward()} className="btn btn-interamerican">ANTERIOR</button>
                    <button type="button" onClick={() => stepFoward(synchronousError, datosCliente)} disabled={submitting} className="btn btn-interamerican">{nombreBoton}</button>
                </div>
            </div>
        </form>
    );
}

FormDataCliente = reduxForm({
    form: 'FormDataCliente',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(FormDataCliente)

const mapStateToProps = state => ({
    synchronousError: getFormSyncErrors('FormDataCliente')(state),
    initialValues: {
        Edad: 25,
        FechaArrivo: moment(new Date()).format("YYYY/MM/DD hh:mm a")
    },
    datosCliente: {
        nombres: selector(state, 'Nombres'),
        apellidos: selector(state, 'Apellidos'),
        correo: selector(state, 'Correo'),
        codPostal: selector(state, 'CodPostal'),
        telefono: selector(state, 'Telefono'),
        edad: selector(state, 'Edad'),
        comentarios: selector(state, 'Comentarios'),
        aerolinea: selector(state, 'Aerolinea'),
        noVuelo: selector(state, 'NoVuelo'),
        fechaArrivo: selector(state, 'FechaArrivo'),
    }
})

const mapDispatchToProps = dispatch => {
    return {
        stepBackward: () => {
            dispatch(changeStepForm({ stepForm: STEPS.COBERTURAS }))
            window.scrollTo(0, 0);
        },
        stepFoward: (values, datosCliente) => {
            // debugger
            if(datosCliente.edad <= 24){
                dispatch(checkCobertura({ id: "MENORES", checked: true }))
            }
            
            dispatch(submit('FormDataCliente'));

            if (!values.Nombres && !values.Apellidos && !values.Correo && !values.CodPostal && !values.Telefono && !values.Edad && !values.Aerolinea && !values.NoVuelo) {
                dispatch(changeStepForm({ stepForm: STEPS.CONFIRMACION }));
                window.scrollTo(0, 0);
            }
        },
        checkCobertura: value => dispatch(checkCobertura(value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormDataCliente);